import {
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import { PowerSettingsNew } from "@material-ui/icons";
import React from "react";

import { withFirebase } from "../Firebase";

const SignOutListItem = ({ firebase, lang, iconColor }) => (
  <ListItem button onClick={firebase.doSignOut}>
    <ListItemIcon>
      <PowerSettingsNew color={iconColor} />
    </ListItemIcon>
    <ListItemText>{lang === "es" ? "Cerrar Sesión" : "Sing Out"}</ListItemText>
  </ListItem>
);

export default withFirebase(SignOutListItem);
